<script>
import Layout from "../../layouts/main";
import ContactUsApi from "@/services/contact-us-api";
import appConfig from "@/app.config";

export default {
  name: "Faq",
  page: {
    title: "Contactez-nous",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {Layout},
  data() {
    return {
      contactUs:{ firstName: '' , secondName: '' , mail: '' , message:''},

    };
  },
  methods: {
    sendContactUsMail(){
      ContactUsApi.sendContactUsMail(this.contactUs).then((result)=>{
        if(result){
          this.contactUs={ firstName: '' , secondName: '' , mail: '' , message:''}
        }
      })
    },
  }
};
</script>

<template>
  <Layout>
    <div class="container py-4">
      <!-- Page Heading -->

      <div class="text-left mb-5 mx-4">
        <h1 class="text-primary font-weight-bold">
          {{ $t('contact.heading') }}
        </h1>
        <p class="text-muted lead">
          {{ $t('contact.subheading') }}
        </p>
      </div>

      <div class="row">
        <!-- Contact contactUs -->
        <div class="col-12 col-lg-6 mb-4">
          <div class="card p-4 mx-3 shadow-sm ">
            <form @submit.prevent="sendContactUsMail">
              <div class="form-group">
                <label for="firstName">{{ $t('contact.firstName') }}</label>
                <input
                  type="text"
                  id="firstName"
                  class="form-control"
                  v-model="contactUs.firstName"
                  :placeholder="$t('contact.firstNamePlaceholder')"
                  required
                >
              </div>

              <div class="form-group">
                <label for="lastName">{{ $t('contact.lastName') }}</label>
                <input
                  type="text"
                  id="lastName"
                  class="form-control"
                  v-model="contactUs.secondName"
                  :placeholder="$t('contact.lastNamePlaceholder')"
                  required
                >
              </div>

              <div class="form-group">
                <label for="email">{{ $t('contact.email') }}</label>
                <input
                  type="email"
                  id="email"
                  class="form-control"
                  v-model="contactUs.mail"
                  :placeholder="$t('contact.emailPlaceholder')"
                  required
                >
              </div>

              <div class="form-group">
                <label for="message">{{ $t('contact.message') }}</label>
                <textarea
                  id="message"
                  class="form-control"
                  v-model="contactUs.message"
                  :placeholder="$t('contact.messagePlaceholder')"
                  rows="4"
                  required
                ></textarea>
              </div>

              <button type="submit" class="btn btn-primary bg-primary text-white font-weight-bold w-100">
                {{ $t('contact.submit') }}
              </button>
            </form>
          </div>
        </div>

        <!-- Info Cards -->
        <div class="col-12 col-lg-6">
          <!-- Technical Support Card -->
          <div class="card  info-card mb-3 p-3 mx-3 shadow-sm">
            <div class="row no-gutters align-items-start">
              <div class="col-2 d-flex align-items-center justify-content-center">
                <img alt="i1" width="60" src="@/assets/icons/i1.png"/>
              </div>
              <div class="col">
                <h5 class="font-weight-bold text-primary">{{ $t('infoCards.support.title') }}</h5>
                <p class="text-muted">{{ $t('infoCards.support.text') }}</p>
                <a :href="'mailto:' + $t('infoCards.support.email')" class="text-secondary font-weight-bold">
                  {{ $t('infoCards.support.email') }}
                </a>
              </div>
            </div>
          </div>

          <!-- Location Card -->
         <div
            v-for="loc in ['location1', 'location2']"
            :key="loc"
            class="card info-card m-3 p-3 shadow-sm"
          >
            <div class="row no-gutters align-items-start">
              <div class="col-2 d-flex align-items-center justify-content-center">
                <img alt="i2" width="60" src="@/assets/icons/i2.png" />
              </div>
              <div class="col">
                <h5 class="font-weight-bold text-primary">
                  {{ $t(`infoCards.${loc}.title`) }}
                </h5>
                <p class="small font-weight-medium">
                  {{ $t(`infoCards.${loc}.address`) }}
                </p>
              </div>
            </div>
          </div>

          <!-- Sales Card -->
          <div class="card info-card m-3 p-3 shadow-sm">
            <div class="row no-gutters align-items-start">
              <div class="col-2 d-flex align-items-center justify-content-center">
                <img alt="i3" width="60" src="@/assets/icons/i3.png"/>
              </div>
              <div class="col">
                <h5 class="font-weight-bold text-primary">{{ $t('infoCards.sales.title') }}</h5>
                <p class="text-muted">{{ $t('infoCards.sales.text') }}</p>
                <a :href="'tel:' + $t('infoCards.sales.phone')" class="btn btn-light btn-sm font-weight-bold">
                  {{ $t('infoCards.sales.phoneDisplay') }}
                </a>
              </div>
            </div>
          </div>




        </div>

        <div class="card m-3 shadow-sm border-0 overflow-hidden position-relative" style="height: 250px; width: 100%;">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1460.0580770375461!2d10.728936786540466!3d34.76265888956687!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1301d36a6f37e183%3A0x7e76301bd91bc3e7!2sComplexe%20Commercial%20MAHSOUNA%2C%20Rue%20Cheikh%20Mahmoud%20Krichen%2C%20Sfax%203062!5e0!3m2!1sfr!2stn!4v1769177489004!5m2!1sfr!2stn"
            width="100%"
            height="100%"
            style="border:0;"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>

        </div>

      </div>
    </div>
  </Layout>
</template>

<style scoped>
h1, h5 {
  color: #181711;
}

.info-card:hover {
  border: 1px solid #1d3266;
}


</style>
